<template>
  <div>
    <div class="text-center">
      <h4 v-if="courses_wrapper_id && coursesWrapper">
        {{
          $getVisibleNames(
            "mesh.coursewrapper",
            false,
            "Envoltorio de Asignaturas"
          )
        }}: {{ coursesWrapper.name }}
      </h4>
      <h4 class="mt-3 mb-3" v-else>
        {{ $getVisibleNames("manual.matriz_2", false, "Matriz 2") }}:
        {{ $getVisibleNames("mesh.egressprofilematter", true, "Asignaturas") }}
        <span v-if="career"
          >{{ " " + $t("matrix2.matrix2View.of") + " " + career.name }}
        </span>
      </h4>
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <template v-if="allows_crud && can_update && tabIndex == 0">
            <ButtonMedium
              :tooltip_text="`${$t('reusable.common.add')} ${$getVisibleNames(
                'mesh.egressprofilematter',
                false,
                'Asignatura'
              )}`"
              :click_button="() => $bvModal.show('new-matter-modal')"
              :custom_class="`mb-2 ml-3`"
              :text_button="$t('reusable.common.add')"
              :icon="'plus'"
              :variant="'primary'"
            >
            </ButtonMedium>
          </template>
          <b-button
            v-if="courses_wrapper_id == null"
            variant="primary"
            size="sm"
            class="mb-2 ml-3 noprint"
            @click="$bvModal.show('course-wrapper-modal')"
            >{{
              $getVisibleNames(
                "mesh.coursewrapper",
                false,
                "Envoltorio de Asignaturas"
              )
            }}</b-button
          >
          <b-button
            v-else
            variant="secondary"
            size="sm"
            class="mb-2 ml-3 noprint"
            @click="
              () => {
                $router.push({
                  name: 'Matrix2View',
                  params: {
                    egress_profile_id: egress_profile_id,
                  },
                });
              }
            "
            >{{ $t("matrix2.matrix2View.back") }}</b-button
          >
          <RemoveEPMattersComponent
            v-if="
              user &&
              user.is_superuser &&
              allows_crud &&
              courses_wrapper_id == null
            "
            :egress_profile_id="egress_profile_id"
            :allows_crud="allows_crud"
          >
          </RemoveEPMattersComponent>
          <ButtonMedium
            v-if="collapsibleRowIds.length > 0"
            :tooltip_text="
              allRowsExpanded
                ? $t('matrix2.matrix2View.collapseAllRows')
                : $t('matrix2.matrix2View.expandAllRows')
            "
            :click_button="toggleAllRows"
            :custom_class="`mb-2 ml-3`"
            :text_button="''"
            :icon="allRowsExpanded ? 'arrows-collapse' : 'arrows-expand'"
            :variant="'primary'"
          >
          </ButtonMedium>
        </div>
        <template v-if="courses_wrapper_id == null">
          <div class="d-flex align-items-center">
            <!-- <template
              v-if="
                user &&
                institution &&
                institution.kl_artificial_intelligence_report &&
                egressProfile &&
                !egressProfile.is_closed &&
                (user.is_superuser ||
                  [
                    'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                    'DIRECTIVOS ACADÉMICOS (CAMPUS)',
                    'DIRECTIVOS FACULTAD O ESCUELA',
                    'DIRECTORES DE CARRERA',
                  ].some((group) => user.group_names.includes(group)))
              "
            >
              <AiReportModal
                :reportConfig="{
                  inteligence_option: 5,
                  title: $t('matrix2.matrix2View.evolutiveReportTitle', {
                    entity: $getVisibleNames(
                      'manual.matriz_2',
                      false,
                      'Matriz 2'
                    ),
                  }),
                }"
                :egress_profile_id="egress_profile_id"
                :subtitle="
                  career
                    ? career.name
                    : $getVisibleNames(
                        'mesh.egressprofile',
                        false,
                        'Perfil de Egreso'
                      )
                "
                :buttonText="
                  $t('matrix2.matrix2View.evolutiveButtonText', {
                    entity: $getVisibleNames(
                      'manual.matriz_2',
                      false,
                      'Matriz 2'
                    ),
                  })
                "
                :buttonTooltip="
                  $t('matrix2.matrix2View.evolutiveButtonTooltip', {
                    entity: $getVisibleNames(
                      'manual.matriz_2',
                      false,
                      'Matriz 2'
                    ),
                  })
                "
                :check_has_data="egressProfile && egressProfile.is_closed"
                class="ml-2"
              />
              <AiReportModal
                :reportConfig="{
                  inteligence_option: 6,
                  title: $t('matrix2.matrix2View.improvementReportTitle', {
                    entity: $getVisibleNames(
                      'manual.matriz_2',
                      false,
                      'Matriz 2'
                    ),
                  }),
                }"
                :egress_profile_id="egress_profile_id"
                :subtitle="
                  career
                    ? career.name
                    : $getVisibleNames(
                        'mesh.egressprofile',
                        false,
                        'Perfil de Egreso'
                      )
                "
                :buttonText="
                  $t('matrix2.matrix2View.improvementButtonText', {
                    entity: $getVisibleNames(
                      'manual.matriz_2',
                      false,
                      'Matriz 2'
                    ),
                  })
                "
                :buttonTooltip="
                  $t('matrix2.matrix2View.improvementButtonTooltip', {
                    raEntity: $getVisibleNames(
                      'teaching.ramicro',
                      true,
                      'Resultados de Aprendizaje'
                    ),
                  })
                "
                :check_has_data="egressProfile && egressProfile.is_closed"
                class="ml-2 mr-2"
              />
            </template> -->
            <ContainerButtonsDownload
              v-if="
                user &&
                institution &&
                institution.kl_artificial_intelligence_report &&
                egressProfile &&
                !egressProfile.is_closed &&
                (user.is_superuser ||
                  [
                    'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                    'DIRECTIVOS ACADÉMICOS (CAMPUS)',
                    'DIRECTIVOS FACULTAD O ESCUELA',
                    'DIRECTORES DE CARRERA',
                  ].some((group) => user.group_names.includes(group)))
              "
              :id_button="`col-display-ai-${egress_profile_id}`"
              :tooltip_text="''"
              :text_button="
                $t('egressProfile.egressProfileView.aiActionsButton')
              "
              :variant="'none'"
              :custom_class="'btn-ai-custom'"
              class="mx-2"
            >
              <template #icon>
                <img
                  src="@/assets/icon-ai.svg"
                  alt=""
                  class="icon-btn-ai mr-1"
                />
              </template>
              <template #popover-container-buttons>
                <!-- Solo botones dentro del popover: los modales (reportes y
                   builder) viven en la raíz de la vista, porque el popover
                   destruye su contenido al cerrarse (matando cualquier
                   modal abierto) y su transform atrapa overlays fixed. -->
                <div>
                  <b-button
                    v-if="userHasAiComponent"
                    v-b-tooltip.topleft.v-secondary.noninteractive="{
                      title: $t('matrix2.matrix2View.evolutiveButtonTooltip', {
                        entity: $getVisibleNames(
                          'manual.matriz_2',
                          false,
                          'Matriz 2'
                        ),
                      }),
                      boundary: 'viewport',
                    }"
                    size="sm"
                    variant="none"
                    class="w-100 mb-1 text-left btn-ai-custom"
                    @click="openAiReportModal('evolutive_report_modal')"
                  >
                    <img
                      src="@/assets/icon-ai.svg"
                      alt=""
                      class="icon-btn-ai mr-1"
                    />
                    {{
                      $t("matrix2.matrix2View.evolutiveButtonText", {
                        entity: $getVisibleNames(
                          "manual.matriz_2",
                          false,
                          "Matriz 2"
                        ),
                      })
                    }}
                  </b-button>
                  <b-button
                    v-if="userHasAiComponent"
                    v-b-tooltip.topleft.v-secondary.noninteractive="{
                      title: $t('matrix2.matrix2View.improvementButtonTooltip', {
                        raEntity: $getVisibleNames(
                          'teaching.ramicro',
                          true,
                          'Resultados de Aprendizaje'
                        ),
                      }),
                      boundary: 'viewport',
                    }"
                    size="sm"
                    variant="none"
                    class="w-100 text-left btn-ai-custom"
                    @click="openAiReportModal('improvement_report_modal')"
                  >
                    <img
                      src="@/assets/icon-ai.svg"
                      alt=""
                      class="icon-btn-ai mr-1"
                    />
                    {{
                      $t("matrix2.matrix2View.improvementButtonText", {
                        entity: $getVisibleNames(
                          "manual.matriz_2",
                          false,
                          "Matriz 2"
                        ),
                      })
                    }}
                  </b-button>
                </div>
              </template>
            </ContainerButtonsDownload>
            <ContainerButtonsDownload
              v-if="
                user &&
                ([
                  'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                  'DIRECTIVOS ACADÉMICOS (CAMPUS)',
                  'DIRECTIVOS FACULTAD O ESCUELA',
                  'DIRECTORES DE CARRERA',
                  'DIRECTORES DE CARRERA (CAMPUS)',
                  'ADMINISTRATIVOS INSTRUCCIONALES',
                ].some((group) => user.group_names.includes(group)) ||
                  user.is_superuser)
              "
              :id_button="`col-display-1-${egress_profile_id}`"
              :tooltip_text="''"
              class="mr-3"
            >
              <template #popover-container-buttons>
                <div>
                  <GenericButtonDownload
                    v-if="
                      institution && institution.internal_use_id == 'duoc.cl'
                    "
                    :text_button="`${$t(
                      'matrix2.matrix2View.completitudeAbbr'
                    )} ${
                      matterList.length != currentItemListIds.length
                        ? $t('matrix2.matrix2View.filtered').toUpperCase()
                        : ''
                    }`"
                    :tooltip_text="`${
                      matterList.length != currentItemListIds.length &&
                      currentItemListIds.length > 0
                        ? $t('matrix2.matrix2View.willDownloadOnly') +
                          ' ' +
                          currentItemListIds.length +
                          ' ' +
                          $getVisibleNames(
                            'mesh.egressprofilematter',
                            true,
                            'Asignaturas'
                          )
                        : ''
                    }`"
                    :variant_button="'success'"
                    :click_button="DownloadCompletedPMDXLS"
                    :disabled_button="disabled_button_excel"
                    :icon_excel="true"
                    :class="`w-100 text-left`"
                  ></GenericButtonDownload>
                  <GenericButtonDownload
                    :text_button="`${$t(
                      'matrix2.matrix2View.reportOf'
                    )} ${$getVisibleNames(
                      'mesh.egressprofilematter',
                      true,
                      'Asignaturas'
                    ).toUpperCase()}`"
                    :tooltip_text="``"
                    :variant_button="'success'"
                    :click_button="DownloadEgressProfileMatterExcel"
                    :disabled_button="disabled_button_excel"
                    :icon_excel="true"
                    :class="`w-100 mt-1 text-left`"
                  ></GenericButtonDownload>
                  <GenericButtonDownload
                    v-if="
                      institution && institution.internal_use_id == 'duoc.cl'
                    "
                    :text_button="`${$t('matrix2.matrix2View.formativeMap')} ${
                      matterList.length != currentItemListIds.length
                        ? $t('matrix2.matrix2View.filtered').toUpperCase()
                        : ''
                    }`"
                    :variant_button="'success'"
                    :tooltip_text="`${
                      matterList.length != currentItemListIds.length &&
                      currentItemListIds.length > 0
                        ? $t('matrix2.matrix2View.willDownloadOnly') +
                          ' ' +
                          currentItemListIds.length +
                          ' ' +
                          $getVisibleNames(
                            'mesh.egressprofilematter',
                            true,
                            'Asignaturas'
                          )
                        : ''
                    }`"
                    :click_button="DownloadXLS"
                    :disabled_button="disabled_button_excel"
                    :icon_excel="true"
                    :class="`w-100 mt-1 text-left`"
                  ></GenericButtonDownload>
                  <GenericButtonDownload
                    v-if="
                      institution && institution.internal_use_id == 'duoc.cl'
                    "
                    :text_button="
                      $t('matrix2.matrix2View.teacherProfile').toUpperCase()
                    "
                    :tooltip_text="``"
                    :variant_button="'success'"
                    :click_button="TeacherProfiledXLS"
                    :disabled_button="disabled_button_excel"
                    :icon_excel="true"
                    :class="`w-100 mt-1 text-left`"
                  ></GenericButtonDownload>
                </div>
              </template>
            </ContainerButtonsDownload>
          </div>
        </template>
      </div>
      <div class="container-v-select noprint">
        <span class="mt-1 ml-3 text-filter-formative-line"
          ><strong
            >{{ $t("reusable.common.filterBy") }}
            {{
              $getVisibleNames(
                "mesh.formationline",
                false,
                "Línea De Formación"
              )
            }}:</strong
          ></span
        >
        <v-select
          class="mr-3 ml-1 mt-2 v-select-class"
          style="width: 100%"
          id="select-selected_formative_lines"
          :placeholder="$t('matrix2.matrix2View.selectOneOrSeveral')"
          :options="formationLinesList"
          v-model="selected_formative_lines"
          :reduce="(formationLinesList) => formationLinesList.id"
          :selectable="
            (option) => !selected_formative_lines.includes(option.id)
          "
          @input="() => (visible_formation_line = true)"
          label="name"
          track-by="id"
          size="sm"
          multiple
          :dropdown-should-open="dropdownShouldOpen"
        >
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              {{ $t("reusable.common.noOptions") }} <em>{{ search }}</em
              >.
            </template>
          </template>
        </v-select>
      </div>
    </div>
    <!-- Tabla -->
    <div class="table-responsive">
      <GenericBTable
        :key="visible_formation_line"
        :items="filterMatterList"
        :fields="fields"
        :filter="input_search"
        :filterCustom="filterCustom"
        :current-page="currentPage"
        :per-page="perPage"
        :pagination="10"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :busy="isBusy"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        :delay_input="true"
        :show_pagination="true"
        :search_filter="true"
        :view_filter_by="true"
        :columns_display="true"
        :display_id="'profiles-list'"
        @emitChangeSearchField="changeInputSearch"
        @emitChangeFilterOn="changeFilterOn"
        :sticky-header="stickyHeaderSize"
      >
        <template #cell(order)="row">
          <div class="d-flex align-items-center justify-content-center">
            <b-button
              v-if="isRowCollapsible(row.item)"
              variant="none"
              size="sm"
              class="collapse-toggle-btn p-0 mr-1 noprint"
              @click="toggleRowExpansion(row.item.id)"
              v-b-tooltip.v-secondary.noninteractive="
                isRowExpanded(row.item.id)
                  ? $t('matrix2.matrix2View.collapseRow')
                  : $t('matrix2.matrix2View.expandRow')
              "
            >
              <b-icon
                :icon="
                  isRowExpanded(row.item.id) ? 'chevron-up' : 'chevron-down'
                "
              ></b-icon>
            </b-button>
            <span>{{ row.item.order }}</span>
          </div>
        </template>
        <template #cell(name)="row">
          <div
            class="align-middle text-left"
            :class="[
              row.item.id == last_matter ? 'new-matter-container' : '',
              { 'm2-collapsed': isRowCollapsed(row.item) },
            ]"
          >
            <b-badge
              v-if="
                row.item.matter_code ||
                (institution && institution.use_epm_code && row.item.code)
              "
              variant="none"
              pill
              class="code-matter mb-1"
            >
              <span
                v-if="row.item.matter_code"
                v-b-tooltip.v-secondary.noninteractive="
                  `${$getVisibleNames('manual.matter_code', false, 'Código')}`
                "
                >{{ row.item.matter_code }}</span
              >
              <template
                v-if="
                  institution &&
                  institution.use_epm_code &&
                  row.item.code &&
                  row.item.code !== row.item.matter_code
                "
              >
                <template v-if="row.item.matter_code">-</template>
                <span
                  v-b-tooltip.v-secondary.noninteractive="
                    `${$getVisibleNames(
                      'manual.ep_matter_code',
                      false,
                      'Código'
                    )}`
                  "
                  >{{ row.item.code }}</span
                >
              </template>
            </b-badge>

            <b-badge
              v-if="institution && institution.internal_use_id != 'duoc.cl'"
              variant="none"
              pill
              class="code-matter mb-1 px-2"
              v-b-tooltip.v-secondary.noninteractive="
                $t('matrix2.matrix2View.planLevel')
              "
              >{{ row.item.plan_level }}</b-badge
            >
            <div class="text-left ml-4"></div>
            <div class="d-flex">
              <div>
                <b-link
                  :to="{
                    name: 'MatterProgramView',
                    params: { matter_id: row.item.id },
                  }"
                  v-b-tooltip.v-secondary.noninteractive="
                    $t('reusable.common.goToTooltip', {
                      entity: $getVisibleNames(
                        'manual.matter_program',
                        false,
                        'Programa de la Asignatura'
                      ),
                    })
                  "
                  class="matter-link"
                >
                  <template v-if="allows_crud">
                    <template v-if="row.item.is_closed">
                      <b-icon icon="lock" scale="1"></b-icon>
                    </template>
                    <template v-else>
                      <b-icon icon="unlock" scale="1"></b-icon>
                    </template>
                  </template>
                  {{ row.item.name.toUpperCase() }}
                </b-link>
                <template v-if="!row.item.use_matter_values">
                  <template v-if="row.item.modalities.length > 0">
                    <b-badge
                      :id="`modalities-badge-${row.item.id}`"
                      class="modalities-badge"
                    >
                      {{
                        row.item.modalities ? row.item.modalities.length : ""
                      }}
                    </b-badge>
                    <ModalitiesPopover
                      :object="row.item"
                      :content="matterModalities(row.item.modalities)"
                      :triggers="'hover'"
                    ></ModalitiesPopover>
                  </template>
                </template>
                <template v-else>
                  <template
                    v-if="
                      oldMatter(row.item) &&
                      oldMatter(row.item).modalities.length > 0
                    "
                  >
                    <b-badge
                      :id="`modalities-badge-${row.item.id}`"
                      class="modalities-badge"
                    >
                      {{ oldMatter(row.item).modalities.length }}
                    </b-badge>
                    <ModalitiesPopover
                      :object="row.item"
                      :content="
                        matterModalities(oldMatter(row.item).modalities)
                      "
                      :triggers="'hover'"
                    ></ModalitiesPopover>
                  </template>
                </template>
                <div v-if="allows_crud && can_update" class="button-div">
                  <ButtonSmall
                    :tooltip_text="`${$t(
                      'reusable.common.edit'
                    )} ${$getVisibleNames(
                      'mesh.egressprofilematter',
                      false,
                      'Asignatura'
                    )}`"
                    v-can="'teaching.change_matter'"
                    :click_button="
                      () => $bvModal.show(`modal-edit-matter-${row.item.id}`)
                    "
                    :class="`mr-2`"
                    :icon="'square'"
                  ></ButtonSmall>
                  <b-button
                    variant="none"
                    v-can="'teaching.change_matter'"
                    v-if="
                      institution &&
                      institution.show_base_ra &&
                      matterCompetenceIds(row.item).length > 0 &&
                      !isClosedOldMatter(row.item) &&
                      allows_crud &&
                      can_update
                    "
                    @click="
                      $bvModal.show(`modal-copy-study-unit-${row.item.id}`)
                    "
                    v-b-tooltip.v-secondary.noninteractive="
                      $t('matrix2.matrix2View.linkTo', {
                        object: $getVisibleNames(
                          'teaching.basera',
                          false,
                          'RA Base'
                        ),
                        entity: row.item.name,
                      })
                    "
                  >
                    <template v-if="row.item.is_integrative">
                      <b-icon icon="ui-checks"></b-icon>
                    </template>
                    <template v-else
                      ><b-icon icon="ui-radios"></b-icon
                    ></template>
                  </b-button>
                </div>
                <b-modal
                  :id="`modal-copy-study-unit-${row.item.id}`"
                  :title="
                    $t('matrix2.matrix2View.linkTo', {
                      object: $getVisibleNames(
                        'teaching.basera',
                        false,
                        'RA Base'
                      ),
                      entity: row.item.name,
                    })
                  "
                  size="lg"
                  hide-footer
                >
                  <SelectedRaBase
                    :matrix2_view="true"
                    :competences_ids="matterCompetenceIds(row.item)"
                    :egress_profile_id="egress_profile_id"
                    :egress_profile_matter="row.item"
                    :matter_id="row.item.matter"
                    @closeModal="
                      $bvModal.hide(`modal-copy-study-unit-${row.item.id}`)
                    "
                  ></SelectedRaBase>
                </b-modal>
                <b-modal
                  :id="`modal-edit-matter-${row.item.id}`"
                  hide-footer
                  :title="`${$t('reusable.common.edit')} ${$getVisibleNames(
                    'mesh.egressprofilematter',
                    false,
                    'Asignatura'
                  )}`"
                  size="xl"
                  ignore-enforce-focus-selector="#sidebar-right"
                >
                  <MatterForm
                    :Matter="row.item"
                    :egress_profile_id="row.item.egress_profile"
                    :show_delete_button="can_delete"
                    :can_update="can_update"
                    :can_delete="can_delete"
                    @update="slotUpdatedMatter"
                    @updated="slotUpdatedMatter"
                  ></MatterForm>
                </b-modal>
              </div>
            </div>
          </div>
        </template>
        <template #cell(competences)="row">
          <div
            class="content-div"
            :class="[
              row.item.id == last_matter ? 'new-matter-container' : '',
              { 'm2-collapsed': isRowCollapsed(row.item) },
            ]"
          >
            <div
              v-for="competence in matterCompetences(row.item)"
              :key="`competence-${row.item.matter}-${competence.id}`"
            >
              <section
                class="d-flex"
                :title="
                  competence.type
                    ? competenceTypes.find((x) => x.id == competence.type).name
                    : ''
                "
              >
                <SentenceContainer
                  class="mt-1"
                  :unique_id="
                    row.item.id +
                    '-' +
                    competence.id +
                    '-' +
                    competence.full_sentence
                  "
                  :Sentence="competence"
                >
                  <template #order>
                    <strong class="mt-1 competence-order mr-1">
                      <span v-if="competence.cycle == null">
                        {{ competence.order }}
                      </span>
                      <span v-else>
                        {{ cycleOrder(competence.cycle) }}.{{ competence.order
                        }}<span
                          v-if="
                            competence.sub_order > 0 &&
                            institution &&
                            institution.show_competence_sub_order
                          "
                          >.{{ competence.sub_order }}</span
                        ></span
                      ></strong
                    >
                  </template>
                </SentenceContainer>
              </section>
            </div>
            <MatterCompetencesModal
              :matter="row.item"
              :egressProfile="egressProfile"
              :open_modal="open_competence_modal == row.item.id ? true : false"
              :allows_crud="
                !row.item.is_closed ? allows_crud && can_update : false
              "
            ></MatterCompetencesModal>
            <span
              v-if="showColumnCountBadge(row.item, 'competences')"
              class="m2-more-indicator noprint"
              @click="toggleRowExpansion(row.item.id)"
              v-b-tooltip.v-secondary.noninteractive="
                $t('matrix2.matrix2View.showAllItems', {
                  count: columnItemCount(row.item, 'competences'),
                })
              "
            >
              <b-icon icon="chevron-down" scale="0.9"></b-icon>
              {{ columnItemCount(row.item, "competences") }}
            </span>
          </div>
        </template>
        <template #cell(realization_scopes)="row">
          <div
            class="content-div"
            :class="{ 'm2-collapsed': isRowCollapsed(row.item) }"
          >
            <!-- Solo los nombres van a la izquierda: el botón queda centrado como el de
                 las competencias -->
            <div
              v-for="realization_scope in realizationScopesByMatter[
                row.item.id
              ] || []"
              :key="`matter-${row.item.id}-realization-scope-${realization_scope.id}`"
              :title="realization_scope.description"
              class="mt-1 text-left"
            >
              {{ realization_scope.name }}
            </div>
            <!-- Edición directa, además del paso que se abre al guardar las competencias.
                 Mismo permiso que editar competencias: ambos hacen PATCH a la asignatura. -->
            <div
              v-if="canEditRealizationScopes(row.item)"
              v-can="'teaching.change_matter'"
            >
              <ButtonSmall
                :tooltip_text="`${$t('reusable.common.edit')} ${$getVisibleNames(
                  'mesh.egressprofilerealizationscope',
                  true,
                  'Ámbitos de realización'
                )}`"
                :click_button="() => openRealizationScopesModal(row.item)"
                :icon="'square'"
              ></ButtonSmall>
            </div>
          </div>
        </template>
        <template #cell(temp_competence_unit)="row">
          <div class="" :class="{ 'm2-collapsed': isRowCollapsed(row.item) }">
            <CompetenceUnitCell
              :profileMatter="row.item"
              :matter_id="row.item.matter"
              :allows_crud="!isClosedOldMatter(row.item) ? allows_crud : false"
              :can_update="can_update"
              :can_delete="can_delete"
            ></CompetenceUnitCell>
            <span
              v-if="showColumnCountBadge(row.item, 'temp_competence_unit')"
              class="m2-more-indicator noprint"
              @click="toggleRowExpansion(row.item.id)"
              v-b-tooltip.v-secondary.noninteractive="
                $t('matrix2.matrix2View.showAllItems', {
                  count: columnItemCount(row.item, 'temp_competence_unit'),
                })
              "
            >
              <b-icon icon="chevron-down" scale="0.9"></b-icon>
              {{ columnItemCount(row.item, "temp_competence_unit") }}
            </span>
          </div>
        </template>
        <template #cell(ra_macro)="row"
          ><div
            class="ra-macro-div"
            :class="[
              row.item.id == last_matter ? 'new-matter-container' : '',
              { 'm2-collapsed': isRowCollapsed(row.item) },
            ]"
          >
            <section v-if="getRaMacro(row.item.matter)">
              <SentenceContainer :Sentence="getRaMacro(row.item.matter)">
              </SentenceContainer>
            </section>
            <div v-if="!isClosedOldMatter(row.item) ? allows_crud : false">
              <ButtonSmall
                v-if="getRaMacro(row.item.matter) && allows_crud && can_update"
                v-can="'teaching.change_ramacro'"
                :tooltip_text="`${$t(
                  'reusable.common.edit'
                )} ${$getVisibleNames('teaching.ramacro', false, 'RA Macro')}`"
                :click_button="() => openModalEdit(row.item.id)"
                :class="`mr-2`"
                :icon="'square'"
              ></ButtonSmall>
              <ButtonSmall
                v-if="!getRaMacro(row.item.matter) && allows_crud && can_update"
                v-can="'teaching.change_ramacro'"
                :tooltip_text="`${$t(
                  'reusable.common.create'
                )} ${$getVisibleNames('teaching.ramacro', false, 'RA Macro')}`"
                :click_button="() => openModalCreate(row.item.id)"
                :icon="'plus'"
                :variant="'none'"
              >
              </ButtonSmall>
              <b-modal
                :id="`modal-new-ra-macro-${row.item.id}`"
                :title="`${$t('reusable.common.create')} ${$getVisibleNames(
                  'teaching.ramacro',
                  false,
                  'RA Macro'
                )}.`"
                size="lg"
                hide-footer
                ignore-enforce-focus-selector="#sidebar-right"
                @hide="hideModalRaMacro"
              >
                <RAMacroForm
                  :matter_id="row.item.matter"
                  @created="$bvModal.hide(`modal-new-ra-macro-${row.item.id}`)"
                  @create="$bvModal.hide(`modal-new-ra-macro-${row.item.id}`)"
                ></RAMacroForm>
              </b-modal>
              <b-modal
                :id="`modal-edit-ra-macro-${row.item.id}`"
                :title="`${$t('reusable.common.edit')} ${$getVisibleNames(
                  'teaching.ramacro',
                  false,
                  'RA Macro'
                )}.`"
                size="lg"
                hide-footer
                ignore-enforce-focus-selector="#sidebar-right"
                @hide="hideModalRaMacro"
              >
                <RAMacroForm
                  :matter_id="row.item.matter"
                  :RAMacro="getRaMacro(row.item.matter)"
                  :show_delete_button="allows_crud && can_delete"
                  @update="$bvModal.hide(`modal-edit-ra-macro-${row.item.id}`)"
                  @updated="$bvModal.hide(`modal-edit-ra-macro-${row.item.id}`)"
                  @deleted="$bvModal.hide(`modal-edit-ra-macro-${row.item.id}`)"
                ></RAMacroForm>
              </b-modal>
            </div>
          </div>
        </template>
        <template #cell(ra_micro)="row">
          <b-modal
            :id="`modal-new-study-unit-${row.item.id}`"
            :title="`${$t('reusable.common.create')} ${$getVisibleNames(
              'teaching.ramicro',
              false,
              'RA Micro'
            )}`"
            size="lg"
            hide-footer
            ignore-enforce-focus-selector="#sidebar-right"
            @hide="hideModalRaMacro()"
          >
            <StudyUnitForm
              :egress_profile_matter_id="row.item.id"
              :matter_id="row.item.matter"
              :show_temp_competence_unit="true"
              :can_update="can_update"
              :can_delete="can_delete"
              @created="$bvModal.hide(`modal-new-study-unit-${row.item.id}`)"
              @close_modal="
                $bvModal.hide(`modal-new-study-unit-${row.item.id}`)
              "
            ></StudyUnitForm>
          </b-modal>
          <div
            class="ra-micro-container"
            :class="[
              row.item.id == last_matter ? 'new-matter-container' : '',
              { 'm2-collapsed': isRowCollapsed(row.item) },
            ]"
          >
            <ButtonSmall
              v-can="'teaching.change_matter'"
              v-if="!isClosedOldMatter(row.item) && allows_crud && can_update"
              :tooltip_text="`${$t('reusable.common.add')} ${$getVisibleNames(
                'teaching.ramicro',
                false,
                'RA Micro'
              )}`"
              :click_button="() => openModalStudyUnit(row.item.id)"
              :icon="'plus'"
              :variant="'none'"
            >
            </ButtonSmall>
            <template v-if="studyUnitList(row.item).length > 0">
              <template v-for="study_unit in studyUnitList(row.item)">
                <StudyUnitCell
                  v-if="study_unit"
                  :egress_profile_matter_id="row.item.id"
                  :study_unit_id="study_unit.id"
                  :key="`study-unit-cell-${study_unit.id}`"
                  :matter_id="row.item.matter"
                  :allows_crud="
                    !isClosedOldMatter(row.item) ? allows_crud : false
                  "
                  :can_update="can_update"
                  :can_delete="can_delete"
                  class="ra-micro-content"
                ></StudyUnitCell>
              </template>
            </template>
            <template v-else>
              {{ $t("reusable.common.notApplicable") }}
            </template>
            <span
              v-if="showColumnCountBadge(row.item, 'ra_micro')"
              class="m2-more-indicator noprint"
              @click="toggleRowExpansion(row.item.id)"
              v-b-tooltip.v-secondary.noninteractive="
                $t('matrix2.matrix2View.showAllItems', {
                  count: columnItemCount(row.item, 'ra_micro'),
                })
              "
            >
              <b-icon icon="chevron-down" scale="0.9"></b-icon>
              {{ columnItemCount(row.item, "ra_micro") }}
            </span>
          </div>
        </template>
        <template #cell(methodological_strategies)="row">
          <div
            :class="[row.item.id == last_matter ? 'new-matter-container' : '']"
          >
            <MethodologicalStrategiesCell
              :ProfileMatter="row.item"
              :allows_crud="
                !isClosedOldMatter(row.item) ? allows_crud && can_update : false
              "
            ></MethodologicalStrategiesCell>
          </div>
        </template>
      </GenericBTable>
    </div>
    <!-- Modals -->
    <b-modal
      id="new-matter-modal"
      :title="`${$t('reusable.common.create')} ${$getVisibleNames(
        'mesh.egressprofilematter',
        false,
        'Asignatura'
      )}`"
      size="xl"
      @hide="confirmClose"
      hide-footer
    >
      <MatterForm
        :egress_profile_id="egress_profile_id"
        :courses_wrapper_id="courses_wrapper_id"
        @created="slotCreatedMatter"
        @close_modal="slotCreatedMatter"
        @change_matter_form="() => (change_matter_form = true)"
      ></MatterForm>
    </b-modal>
    <b-modal
      id="course-wrapper-modal"
      :title="`${$getVisibleNames(
        'mesh.coursewrapper',
        false,
        'Envoltorio de Asignaturas'
      )}`"
      size="xl"
      hide-footer
    >
      <CoursesWrapperView
        :egress_profile_id="egress_profile_id"
        :allows_crud="allows_crud"
        @closeModal="$bvModal.hide('course-wrapper-modal')"
      ></CoursesWrapperView>
    </b-modal>

    <!-- Modales de las acciones IA, fuera del popover (ver botones en
    ContainerButtonsDownload): deben sobrevivir al cierre del popover
    y renderizarse a nivel de la vista para cubrir la pantalla. -->
    <AiReportModal
      ref="evolutive_report_modal"
      :show_button="false"
      :reportConfig="{
        inteligence_option: 5,
        title: $t('matrix2.matrix2View.evolutiveReportTitle', {
          entity: $getVisibleNames('manual.matriz_2', false, 'Matriz 2'),
        }),
      }"
      :egress_profile_id="egress_profile_id"
      :subtitle="
        career
          ? career.name
          : $getVisibleNames('mesh.egressprofile', false, 'Perfil de Egreso')
      "
    ></AiReportModal>
    <AiReportModal
      ref="improvement_report_modal"
      :show_button="false"
      :reportConfig="{
        inteligence_option: 6,
        title: $t('matrix2.matrix2View.improvementReportTitle', {
          entity: $getVisibleNames('manual.matriz_2', false, 'Matriz 2'),
        }),
      }"
      :egress_profile_id="egress_profile_id"
      :subtitle="
        career
          ? career.name
          : $getVisibleNames('mesh.egressprofile', false, 'Perfil de Egreso')
      "
    ></AiReportModal>
    <BsModal
      v-if="profileHasRealizationScopes"
      v-model="show_realization_scopes_modal"
      :title="`${$t('reusable.common.selectLabel')} ${$getVisibleNames(
        'mesh.egressprofilerealizationscope',
        true,
        'Ámbitos de realización'
      )}`"
      size="lg"
    >
      <MatterRealizationScopeSelection
        v-if="show_realization_scopes_modal && realization_scopes_matter"
        :egress_profile_matter="realization_scopes_matter"
        :competence_ids="realization_scopes_matter.competences"
        :matrix2_competences="realizationScopesCompetences"
        @close="show_realization_scopes_modal = false"
      ></MatterRealizationScopeSelection>
    </BsModal>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { showLoadingAlert, downloadFileFromResponse } from "@/utils/utils";
import {
  scopesOfEgressProfile,
  scopesOfMatter,
} from "@/utils/realizationScopes";
// import { URL } from "@/utils/globals";

export default {
  name: "Matrix2",
  components: {
    vSelect,
    // StepGenericModal: () => import("@/components/reusable/StepGenericModal"),
    SelectedRaBase: () => import("@/components/reusable/SelectedRaBase"),
    // EvaluationProcedureCell: () => import("./EvaluationProcedureCell"),
    MatterCompetencesModal: () => import("./MatterCompetencesModal"),
    BsModal: () => import("@/components/reusable/bs/BsModal"),
    MatterRealizationScopeSelection: () =>
      import(
        "@/components/mesh/EgressProfile/RealizationScopes/MatterRealizationScopeSelection"
      ),
    RemoveEPMattersComponent: () => import("./RemoveEPMattersComponent"),
    MethodologicalStrategiesCell: () =>
      import("./MethodologicalStrategiesCell"),
    StudyUnitForm: () => import("@/components/reusable/StudyUnitForm"),
    // MatterTable: () => import("./MatterTable"),
    RAMacroForm: () => import("./RAMacroForm"),
    SentenceContainer: () => import("@/components/reusable/SentenceContainer"),
    StudyUnitCell: () => import("./StudyUnitCell"),
    MatterForm: () => import("./MatterForm"),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    ModalitiesPopover: () => import("@/components/reusable/ModalitiesPopover"),
    CoursesWrapperView: () =>
      import("@/components/mesh/Matrix2/CoursesWrapper/CoursesWrapperView"),
    CompetenceUnitCell: () =>
      import(
        "@/components/teaching/MatterProgram/Components/CompetenceUnit/CompetenceUnitCell"
      ),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ContainerButtonsDownload: () =>
      import("@/components/reusable/Buttons/ContainerButtonsDownload"),
    GenericButtonDownload: () =>
      import("@/components/reusable/Buttons/GenericButtonDownload"),
    AiReportModal: () => import("@/components/reusable/AiReportModal"),
    // RaBase: () => import("@/components/reusable/RaBase"),
  },
  props: {
    isBusy: {
      type: Boolean,
      required: true,
    },
    egress_profile_id: {
      type: Number,
      required: true,
    },
    courses_wrapper_id: {
      default: null,
    },
    allows_crud: {
      type: Boolean,
      default: false,
    },
    can_update: {
      type: Boolean,
      default: false,
    },
    can_delete: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // selected_cycle_id: this.cycle_id,
      input_search: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 50,
      pageOptions: [
        5,
        10,
        15,
        { value: 1000, text: this.$t("reusable.common.showAll") },
      ],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filterOn: [],
      window_height: 100,
      loading: false,
      tabIndex: 0,
      last_matter: null,
      open_competence_modal: null,
      item_created_id: null,
      show_realization_scopes_modal: false,
      realization_scopes_matter: null,
      // generic_table_key: 0,
      matters_reports: null,
      prevent_close_modal: false,
      change_matter_form: false,
      current_item: [],
      selected_formative_lines: [],
      timeoutID: null,
      visible_formation_line: false,
      stickyHeaderSize: "600px",
      disabled_button_excel: false,
      // profile_ra_base: [],
      expanded_rows: [],
      // Cantidad mínima de elementos en una columna a partir de la cual la fila se puede contraer
      collapse_threshold: 2,
    };
  },
  computed: {
    ...mapGetters({
      user_access: names.USER_POSITION,
      egressProfiles: names.EGRESS_PROFILES,
      careers: names.CAREERS,
      cycles: names.CYCLES,
      user: "getUser",
      institution: "getInstitution",
      matters: names.MATTERS,
      egressProfileMatters: names.EGRESS_PROFILES_MATTERS,
      profile_cycles: names.PROFILE_CYCLES,
      competenceTypes: names.COMPETENCE_TYPES,
      learningResults: names.LEARNING_RESULTS,
      profile_competences: names.PROFILE_COMPETENCES,
      studyUnits: names.STUDY_UNITS,
      formationLines: names.FORMATION_LINES,
      methodologicalStrategies: names.METHODOLOGICAL_STRATEGIES,
      competences: names.COMPETENCES,
      ra_macros: names.RA_MACROS,
      modalities: names.MODALITIES,
      ra_bases: names.RA_BASES,
      courses_wrapper: names.COURSES_WRAPPER,
      competence_units: names.COMPETENCE_UNITS,
      realization_scopes: names.REALIZATION_SCOPES,
    }),
    egressProfile() {
      return this.egressProfiles.find((x) => x.id == this.egress_profile_id);
    },
    usesRealizationScopes() {
      return this.$usesRealizationScopes(this.institution);
    },
    profileHasRealizationScopes() {
      return (
        this.usesRealizationScopes &&
        scopesOfEgressProfile(this.realization_scopes, this.egress_profile_id)
          .length > 0
      );
    },
    // Columna de ámbitos (solo si la institución los usa y el perfil tiene): fuera del modo
    // edición solo si alguna asignatura tiene ámbitos; en modo edición siempre, para
    // poder asignarlos con el botón de la celda.
    showsRealizationScopes() {
      if (!this.profileHasRealizationScopes) return false;
      if (this.allows_crud && this.can_update) return true;
      return Object.values(this.realizationScopesByMatter).some(
        (realization_scopes) => realization_scopes.length > 0
      );
    },
    // Ámbitos de realización vigentes de cada asignatura del perfil, por id (igual que
    // en la Matriz 3): los elegidos que siguen vinculados a alguna de sus competencias.
    realizationScopesByMatter() {
      if (!this.profileHasRealizationScopes) return {};
      const profile_scopes = scopesOfEgressProfile(
        this.realization_scopes,
        this.egress_profile_id
      );
      const profile_competences = this.profile_competences.filter(
        (x) => x.egress_profile == this.egress_profile_id
      );
      const by_matter = {};
      this.matterList.forEach((egress_profile_matter) => {
        by_matter[egress_profile_matter.id] = scopesOfMatter(
          profile_scopes,
          profile_competences,
          egress_profile_matter
        );
      });
      return by_matter;
    },
    // Competencias del perfil con sus ámbitos, en el formato que espera la selección
    // (id = id de la competencia, no del vínculo)
    realizationScopesCompetences() {
      return this.profile_competences
        .filter((x) => x.egress_profile == this.egress_profile_id)
        .map((x) => ({
          id: x.competence,
          realization_scopes: x.realization_scopes || [],
        }));
    },
    career() {
      if (!this.egressProfile) return null;
      return this.careers.find((x) => x.id == this.egressProfile.career);
    },
    userHasAiComponent() {
      // Mismo gating que el botón interno de AiReportModal (que aquí se
      // reemplaza por botones simples dentro del popover).
      return (
        this.user &&
        (this.user.user_data == null ||
          (this.user.user_data && this.user.user_data.ai_component))
      );
    },
    coursesWrapper() {
      if (!this.courses_wrapper_id) return null;
      return this.courses_wrapper.find((x) => x.id == this.courses_wrapper_id);
    },
    coursesWrapperList() {
      return this.courses_wrapper.filter(
        (x) => x.egress_profile == this.egress_profile_id
      );
    },
    wrapperMatterIds() {
      let list = [];
      this.coursesWrapperList.forEach((x) => {
        if (this.courses_wrapper_id == null)
          list = list.concat(x.egress_profile_matters);
        else if (
          x.id == this.courses_wrapper_id &&
          this.courses_wrapper_id != null
        )
          list = list.concat(x.egress_profile_matters);
      });
      return [...new Set(list)];
    },
    matterList() {
      let list = [];
      if (this.courses_wrapper_id == null)
        list = this.egressProfileMatters.filter(
          (x) =>
            x.egress_profile == this.egress_profile_id &&
            !this.wrapperMatterIds.includes(x.id)
          //  &&
          // x.cycle == this.selected_cycle_id
        );
      else if (this.courses_wrapper_id != null)
        list = this.egressProfileMatters.filter(
          (x) =>
            x.egress_profile == this.egress_profile_id &&
            this.wrapperMatterIds.includes(x.id)
        );
      list = list.sort(function (a, b) {
        if (a.order > b.order) return 1;
        if (a.order < b.order) return -1;
        return 0;
      });
      return list.map((x) => {
        const matter = this.matters.find((m) => m.id == x.matter);
        return {
          ...x,
          name: matter ? matter.name : "",
          matter_code: matter ? matter.code : "",
        };
      });
    },
    matterListFormationLinesIds() {
      return [...new Set(this.matterList.map((x) => x.formation_line))];
    },
    currentItemListIds() {
      let list = this.current_item;
      if (this.selected_formative_lines.length > 0)
        list = list.filter((x) =>
          this.selected_formative_lines.includes(x.formation_line)
        );
      return list;
    },
    formationLinesList() {
      if (!this.career) return [];
      return this.formationLines.filter(
        (x) =>
          x.faculties.includes(this.career.faculty) &&
          this.matterListFormationLinesIds.includes(x.id)
      );
    },
    filterMatterList() {
      let list = this.matterList;
      if (this.selected_formative_lines.length > 0)
        list = list.filter((x) =>
          this.selected_formative_lines.includes(x.formation_line)
        );
      return list;
    },
    collapsibleRowIds() {
      return this.filterMatterList
        .filter((matter) => this.isRowCollapsible(matter))
        .map((matter) => matter.id);
    },
    allRowsExpanded() {
      return this.collapsibleRowIds.every((id) =>
        this.expanded_rows.includes(id)
      );
    },
    fields() {
      return [
        {
          key: "order",
          label: this.$t("matrix2.matrix2View.number"),
          display_column: true,
          sortable: true,
          thClass: "align-middle",
          thStyle: {
            width: "1%",
            position: "sticky !important",
          },
          tdClass: "align-middle",
        },
        {
          key: "name",
          label: this.$getVisibleNames(
            "mesh.egressprofilematter",
            false,
            "Asignatura"
          ).toUpperCase(),
          class: "text-center",
          display_column: true,
          sortable: true,
          thClass: "align-middle",
          thStyle: {
            width: "13%",
            position: "sticky !important",
          },
          tdClass: "align-middle",
        },
        {
          key: "competences",
          class: "text-center",
          label: String(
            this.$getVisibleNames(
              "mesh.competence",
              true,
              "Competencias"
            ).toUpperCase()
          ),
          display_column: true,
          // sortable: true,
          thClass: "align-middle",
          tdClass: "align-middle",
          thStyle: {
            width: "25%",
            position: "sticky !important",
          },
        },
      ]
        .concat(
          // Ámbitos de realización de la asignatura, justo después de sus competencias
          this.showsRealizationScopes
            ? [
                {
                  key: "realization_scopes",
                  class: "text-center",
                  label: String(
                    this.$getVisibleNames(
                      "mesh.egressprofilerealizationscope",
                      true,
                      "Ámbitos de realización"
                    ).toUpperCase()
                  ),
                  display_column: true,
                  thClass: "align-middle",
                  tdClass: "align-middle",
                  thStyle: {
                    width: "12%",
                    position: "sticky !important",
                  },
                },
              ]
            : []
        )
        .concat(
          this.institution && this.institution.internal_use_id == "duoc.cl"
            ? [
                {
                  key: "formation_line",
                  class: "text-center",
                  label: String(
                    this.$getVisibleNames(
                      "mesh.formationline",
                      false,
                      "Línea De Formación"
                    ).toUpperCase()
                  ),
                  display_column: this.visible_formation_line,
                  sortable: true,
                  // La celda muestra el nombre de la línea de formación, no su id
                  sortByFormatted: true,
                  tdClass: "align-middle",
                  thClass: "align-middle",
                  formatter: (value) => this.getFormationLine(value),
                  thStyle: {
                    width: "10%",
                    position: "sticky !important",
                  },
                },
              ]
            : []
        )
        .concat(
          this.institution && this.institution.show_ra_macro
            ? [
                {
                  key: "ra_macro",
                  class: "text-center",
                  label: String(
                    this.$getVisibleNames(
                      "teaching.ramacro",
                      false,
                      "RA MACRO"
                    ).toUpperCase()
                  ),
                  display_column: true,
                  hidden_key: true,
                  tdClass: "align-middle",
                  thClass: "align-middle",
                  thStyle: {
                    width: "15%",
                    position: "sticky !important",
                  },
                },
              ]
            : []
        )
        .concat(
          this.institution && this.institution.show_competence_unit
            ? [
                {
                  key: "temp_competence_unit",
                  label: String(
                    this.$getVisibleNames(
                      "teaching.tempcompetenceunit",
                      false,
                      "Unidad de competencia"
                    ).toUpperCase()
                  ),
                  display_column: true,
                  hidden_key: true,
                  tdClass: "align-middle",
                  thClass: "align-middle",
                  thStyle: {
                    width: "15%",
                    position: "sticky !important",
                  },
                },
              ]
            : []
        )
        .concat([
          {
            key: "ra_micro",
            class: "text-center",
            label: String(
              this.$getVisibleNames(
                "teaching.ramicro",
                false,
                "RA MICRO"
              ).toUpperCase()
            ),
            display_column:
              this.institution && this.institution.internal_use_id != "iacc.cl",
            hidden_key: true,
            thStyle: {
              width: "17%",
              position: "sticky !important",
            },
            thClass: "align-middle",
            tdClass: "align-middle",
          },
        ])
        .concat(
          this.institution && this.institution.internal_use_id == "uniacc.cl"
            ? []
            : [
                {
                  key: "methodological_strategies",
                  class: "text-center",
                  label:
                    this.$getVisibleNames(
                      "mesh.methodologicalstrategy",
                      true,
                      "Estrategias Metodológicas"
                    ).toUpperCase() +
                    " " +
                    this.$t("matrix2.matrix2View.minimum").toUpperCase(),
                  display_column: true,
                  thStyle: {
                    width: "15%",
                    position: "sticky !important",
                  },
                  tdClass: "align-middle",
                },
              ]
        );
    },
    // jsonFields() {
    //   let json_fields = {};
    //   if (this.matters_reports != null)
    //     for (
    //       let index = 0;
    //       index < this.matters_reports.labels.length;
    //       index++
    //     ) {
    //       const label = `<table><th style='display:table-cell;background-color: #9BC2E6; vertical-align: middle; border: .5pt solid black' >${this.matters_reports.labels[index]}</th></table>`;
    //       json_fields[label] = this.matters_reports.labels[index];
    //     }
    //   return json_fields;
    // },
    itemsXLS() {
      let list = [];
      if (this.matters_reports != null) {
        this.matters_reports.datasets.forEach((elements) => {
          let row = {};
          for (let index = 0; index < elements.data.length; index++) {
            const label = this.matters_reports.labels[index];
            const data = elements.data[index];
            row[label] = data;
          }
          list.push(row);
        });
      }
      return list;
    },
  },
  methods: {
    openAiReportModal(ref_name) {
      // Se cierra el popover de acciones IA antes de abrir el modal (que
      // vive fuera del popover); si el reporte viviera dentro del popover,
      // el cierre de este destruiría el componente y su modal se cerraría
      // solo.
      this.$root.$emit("bv::hide::popover");
      if (this.$refs[ref_name]) this.$refs[ref_name].openReport();
    },
    dropdownShouldOpen(VueSelect) {
      if (this.formationLinesList.length > 0) {
        return VueSelect.open;
      }
      return VueSelect.search.length !== 0 && VueSelect.open;
    },
    insertStoreOpenAi(egress_profile_matter_id) {
      this.$store.commit(names.MUTATE_DELETE_FILTER_INTELLIGENCE);
      this.$store.commit(names.MUTATE_DELETE_RULES_FILTER_SELECTOR);

      this.$nextTick(() => {
        this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
          egress_profile_id: this.egress_profile_id,
          egress_profile_matter_id: egress_profile_matter_id,
          intelligence_option: 5,
        });
        this.$store.commit(names.MUTATE_RULES_FILTER_SELECTOR, {
          visible_intelligence_options: [5],
          disabled_selected_egress_profile: true,
        });
      });
    },
    insertStoreOpenAiStudyUnit(egress_profile_matter_id) {
      this.$store.commit(names.MUTATE_DELETE_FILTER_INTELLIGENCE);
      this.$store.commit(names.MUTATE_DELETE_RULES_FILTER_SELECTOR);

      this.$nextTick(() => {
        this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
          egress_profile_id: this.egress_profile_id,
          egress_profile_matter_id: egress_profile_matter_id,
          intelligence_option: 2,
        });
        this.$store.commit(names.MUTATE_RULES_FILTER_SELECTOR, {
          visible_intelligence_options:
            this.institution && this.institution.internal_use_id == "duoc.cl"
              ? [2, 7]
              : [2],
          disabled_selected_egress_profile: true,
          disabled_selected_egress_profile_matter: true,
        });
      });
    },
    hideModalRaMacro() {
      this.$store.commit(names.MUTATE_DELETE_FILTER_INTELLIGENCE);
      this.$store.commit(names.MUTATE_DELETE_RULES_FILTER_SELECTOR);

      this.$nextTick(() => {
        this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
          egress_profile_id: this.egress_profile_id,
          intelligence_option: 2,
        });
        this.$store.commit(names.MUTATE_RULES_FILTER_SELECTOR, {
          visible_intelligence_options: [2, 4, 5, 7],
          egress_profile_matter_id: null,
          competence_unit_id: null,
          disabled_selected_egress_profile: true,
        });
      });
    },
    openModalCreate(egress_profile_matter_id) {
      this.insertStoreOpenAi(egress_profile_matter_id);
      this.$bvModal.show(`modal-new-ra-macro-${egress_profile_matter_id}`);
    },
    openModalEdit(egress_profile_matter_id) {
      this.insertStoreOpenAi(egress_profile_matter_id);
      this.$bvModal.show(`modal-edit-ra-macro-${egress_profile_matter_id}`);
    },
    openModalStudyUnit(egress_profile_matter_id) {
      this.insertStoreOpenAiStudyUnit(egress_profile_matter_id);
      this.$bvModal.show(`modal-new-study-unit-${egress_profile_matter_id}`);
    },
    updateStickyHeaderSize() {
      const viewportHeight = window.innerHeight;
      const newStickyHeaderSize = viewportHeight * 1 + "px"; // Por ejemplo, 100% de la altura del viewport
      this.stickyHeaderSize = newStickyHeaderSize;
    },
    confirmClose(bvModalEvt) {
      if (
        bvModalEvt.trigger === "headerclose" ||
        bvModalEvt.trigger === "event"
      ) {
        this.change_matter_form = false;
        return;
      }
      if (!this.prevent_close_modal && this.change_matter_form) {
        bvModalEvt.preventDefault();
        this.$bvModal
          .msgBoxConfirm(this.$t("matrix2.matrix2View.areYouSureClose"), {
            title: this.$t("matrix2.matrix2View.confirmationRequired"),
            size: "md",
            buttonSize: "md",
            okVariant: "warning",
            okTitle: this.$t("matrix2.matrix2View.yesClose"),
            cancelTitle: this.$t("reusable.common.cancel"),
            footerClass: "p-2",
            hideHeaderClose: true,
            centered: true,
            headerClass: "text-black",
            header: {
              title: this.$t("matrix2.matrix2View.confirmationRequired"),
              class: "text-center",
            },
          })
          .then((value) => {
            if (value) {
              this.prevent_close_modal = true;
              this.$bvModal.hide(bvModalEvt.componentId);
              this.$nextTick(() => {
                this.change_matter_form = false;
                this.prevent_close_modal = false;
              });
            }
          });
      }
    },
    getFormationLine(formation_line_id) {
      const formation_line = this.formationLines.find(
        (x) => x.id === formation_line_id
      );
      return formation_line
        ? formation_line.name
        : this.$t("reusable.common.notApplicable");
    },
    changeInputSearch(input_search) {
      this.input_search = input_search;
      if (input_search.trim() === "") {
        this.current_item = this.matterList;
      } else {
        this.current_item = this.matterList.filter((x) => this.filterCustom(x));
      }
    },
    changeFilterOn(filter_on) {
      this.filterOn = filter_on;
    },
    onFiltered(filteredItems) {
      if (this.selected_formative_lines.length == 0)
        this.current_item = filteredItems;
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    DownloadEgressProfileMatterExcel() {
      this.disabled_button_excel = true;

      showLoadingAlert(
        this.$t("reusable.common.generatingExcel"),
        this.$t("reusable.common.pleaseWaitFile")
      );

      // Usar el wrapper $restful modificado para manejar responseType blob
      this.$restful
        .Post(
          `/teaching/excel_egress_profile_matters_report/`,
          {
            egress_profile: this.egress_profile_id,
            matrix2_report: true,
          },
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          this.$swal.close();

          // Usar la función utilitaria para descargar el blob
          downloadFileFromResponse(
            response,
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            () => {
              // onSuccess callback
              this.disabled_button_excel = false;
            },
            () => {
              // onError callback
              this.disabled_button_excel = false;
              this.$swal.fire(
                this.$t("reusable.common.error"),
                this.$t("reusable.common.downloadError"),
                "error"
              );
            }
          );
        })
        .catch(() => {
          this.disabled_button_excel = false;
          this.$swal.close();
          this.$swal.fire(
            this.$t("reusable.common.error"),
            this.$t("reusable.common.problemGenerating"),
            "error"
          );
        });
    },
    // Reporte Filtrado
    DownloadXLS() {
      this.disabled_button_excel = true;

      showLoadingAlert(
        this.$t("reusable.common.generatingExcel"),
        this.$t("reusable.common.pleaseWaitFile")
      );

      this.$restful
        .Post(
          `/teaching/excel_report_formative_map/`,
          {
            egress_profile: this.egress_profile_id,
            egress_profile_matter_ids: this.currentItemListIds.map((x) => x.id),
          },
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          this.$swal.close();
          // URL + `/teaching/excel_report_formative_map/?egress_profile=${this.egress_profile_id}`,
          if (response) {
            downloadFileFromResponse(
              response,
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              () => {
                this.disabled_button_excel = false;
              },
              () => {
                this.disabled_button_excel = false;
                this.$swal.fire(
                  this.$t("reusable.common.error"),
                  this.$t("reusable.common.downloadError"),
                  "error"
                );
              }
            );
          } else {
            this.disabled_button_excel = false;
            this.$swal.fire(
              this.$t("reusable.common.error"),
              this.$t("reusable.common.generateError"),
              "error"
            );
          }
        })
        .catch(() => {
          this.disabled_button_excel = false;
          this.$swal.close();
          this.$swal.fire(
            this.$t("reusable.common.error"),
            this.$t("reusable.common.problemGenerating"),
            "error"
          );
        });
    },
    TeacherProfiledXLS() {
      this.disabled_button_excel = true;
      showLoadingAlert(
        this.$t("reusable.common.generatingExcel"),
        this.$t("reusable.common.pleaseWaitFile")
      );
      this.$restful
        .Post(
          `/teaching/excel_teaching_profile_report/`,
          {
            egress_profile: this.egress_profile_id,
          },
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          this.$swal.close();
          // URL + `/teaching/excel_report_formative_map/?egress_profile=${this.egress_profile_id}`,
          if (response) {
            downloadFileFromResponse(
              response,
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              () => {
                this.disabled_button_excel = false;
              },
              () => {
                this.disabled_button_excel = false;
                this.$swal.fire(
                  this.$t("reusable.common.error"),
                  this.$t("reusable.common.downloadError"),
                  "error"
                );
              }
            );
          } else {
            this.disabled_button_excel = false;
            this.$swal.fire(
              this.$t("reusable.common.error"),
              this.$t("reusable.common.generateError"),
              "error"
            );
          }
        })
        .catch(() => {
          this.disabled_button_excel = false;
          this.$swal.close();
          this.$swal.fire(
            this.$t("reusable.common.error"),
            this.$t("reusable.common.problemGenerating"),
            "error"
          );
        });
    },
    // Reporte Filtrado
    DownloadCompletedPMDXLS() {
      this.disabled_button_excel = true;
      showLoadingAlert(
        this.$t("reusable.common.generatingExcel"),
        this.$t("reusable.common.pleaseWaitFile")
      );
      this.$restful
        .Post(
          `/mesh/excel_report_duoc_completed_by_pmd/`,
          {
            egress_profile: this.egress_profile_id,
            egress_profile_matter_ids: this.currentItemListIds.map((x) => x.id),
          },
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          this.$swal.close();
          // URL + `/teaching/excel_report_formative_map/?egress_profile=${this.egress_profile_id}`,
          if (response) {
            downloadFileFromResponse(
              response,
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              () => {
                this.disabled_button_excel = false;
              },
              () => {
                this.disabled_button_excel = false;
                this.$swal.fire(
                  this.$t("reusable.common.error"),
                  this.$t("reusable.common.downloadError"),
                  "error"
                );
              }
            );
          } else {
            this.disabled_button_excel = false;
            this.$swal.fire(
              this.$t("reusable.common.error"),
              this.$t("reusable.common.generateError"),
              "error"
            );
          }
        })
        .catch(() => {
          this.disabled_button_excel = false;
          this.$swal.close();
          this.$swal.fire(
            this.$t("reusable.common.error"),
            this.$t("reusable.common.problemGenerating"),
            "error"
          );
        });
    },
    getMatterName(matter_id) {
      const matter = this.matters.find((x) => x.id == matter_id);
      return matter ? matter.name : "";
    },
    getRaMacro(matter_id) {
      const ra = this.ra_macros.find((x) => x.matter == matter_id);
      return ra ? ra : null;
    },
    getRaMacroSentence(matter_id) {
      const ra = this.ra_macros.find((x) => x.matter == matter_id);
      return ra ? ra.sentence : "";
    },
    cycleOrder(cycle_id) {
      if (!cycle_id && !this.egressProfile) return "-";
      let cycleOrder = this.profile_cycles.find(
        (x) => x.cycle == cycle_id && x.egress_profile == this.egressProfile.id
      );
      return cycleOrder ? cycleOrder.order : "-";
    },
    // filterStudyUnits(matter) {
    //   const OldMatter = this.oldMatter(matter);
    //   return (
    //     OldMatter &&
    //     this.studyUnits.some(
    //       (study_unit) =>
    //         OldMatter.study_units.includes(study_unit.id) &&
    //         (this.$filtered(study_unit.name, this.input_search) ||
    //           this.$filtered(study_unit.full_sentence, this.input_search))
    //     )
    //   );
    // },
    filterMethodolicalStategies(matter) {
      const OldMatter = this.oldMatter(matter);
      if (!OldMatter) return false;
      return this.methodologicalStrategies.some(
        (strategy) =>
          OldMatter.methodological_strategies.includes(strategy.id) &&
          this.$filtered(strategy.name, this.input_search)
      );
    },
    getCompetenceFilter(competences_ids) {
      return this.competences.some(
        (competence) =>
          competences_ids.includes(competence.id) &&
          this.$filtered(competence.full_sentence, this.input_search)
      );
    },
    filterCustom(row) {
      const filterOnEmpty = this.filterOn.length === 0;
      let matterNameFiltered = null;
      let competenceFiltered = null;
      let raMacroFiltered = null;
      // let studyUnitsFiltered = null;
      let methodolicalStrategiesFiltered = null;
      let formationLineFiltered = null;
      if (filterOnEmpty || this.filterOn.includes("matter"))
        matterNameFiltered = this.$filtered(row.name, this.input_search);
      if (filterOnEmpty || this.filterOn.includes("competences"))
        competenceFiltered = this.getCompetenceFilter(row.competences);
      if (filterOnEmpty || this.filterOn.includes("ra_macro"))
        raMacroFiltered = this.$filtered(
          this.getRaMacroSentence(row.matter),
          this.input_search
        );
      // if (filterOnEmpty || this.filterOn.includes("ra_micro"))
      //   studyUnitsFiltered = this.filterStudyUnits(row);
      if (filterOnEmpty || this.filterOn.includes("methodological_strategies"))
        methodolicalStrategiesFiltered = this.filterMethodolicalStategies(row);
      if (filterOnEmpty || this.filterOn.includes("formation_line"))
        formationLineFiltered = this.$filtered(
          this.getFormationLine(row.formation_line),
          this.input_search
        );
      const matterCondition =
        matterNameFiltered && this.filterOn.includes("matter");
      const competencesCondition =
        competenceFiltered && this.filterOn.includes("competences");
      const raMacroCondition =
        raMacroFiltered && this.filterOn.includes("ra_macro");
      // const studyUnitsCondition =
      //   studyUnitsFiltered && this.filterOn.includes("ra_micro");
      const methodolicalStrategiesCondition =
        methodolicalStrategiesFiltered &&
        this.filterOn.includes("methodological_strategies");
      const formationLineCondition =
        formationLineFiltered && this.filterOn.includes("formation_line");
      return (
        ((matterNameFiltered ||
          competenceFiltered ||
          raMacroFiltered ||
          formationLineFiltered ||
          // studyUnitsFiltered ||
          methodolicalStrategiesFiltered) &&
          filterOnEmpty) ||
        matterCondition ||
        competencesCondition ||
        raMacroCondition ||
        formationLineCondition ||
        // studyUnitsCondition ||
        methodolicalStrategiesCondition
      );
    },
    studyUnitList(matter) {
      return this.studyUnits
        .filter((x) => x.matter == matter.matter)
        .map((x) => {
          const comopetence_unit = this.competence_units.find(
            (c) => c.id == x.temp_competence_unit
          );
          return {
            ...x,
            competence_unit_order: comopetence_unit
              ? comopetence_unit.order
              : 999,
          };
        })
        .sort(function (a, b) {
          if (a.competence_unit_order > b.competence_unit_order) return 1;
          if (a.competence_unit_order < b.competence_unit_order) return -1;
          if (a.order > b.order) return 1;
          if (a.order < b.order) return -1;
          return 0;
        });
    },
    oldMatter(matter) {
      return this.matters.find((x) => x.id == matter.matter);
    },
    isClosedOldMatter(epm_matter) {
      const matter = this.matters.find((x) => x.id == epm_matter.matter);
      if (!matter) return true;
      else {
        if (matter.is_closed) return true;
        else return false;
      }
    },
    matterCompetenceIds(matter) {
      const competence_ids = this.matterCompetences(matter).map(
        (x) => x.competence
      );
      return competence_ids;
    },
    matterCompetences(matter) {
      let list = [];
      if (
        !matter &&
        !this.egressProfile &&
        !this.profile_competences &&
        !this.competences
      )
        return list;
      matter.competences.forEach((element) => {
        let get_competence = this.competences.find((x) => x.id == element);
        if (get_competence) {
          let instance = this.profile_competences.find(
            (x) =>
              x.competence == get_competence.id &&
              x.egress_profile == this.egressProfile.id
          );
          if (instance) {
            let profile_cycle_order = this.profile_cycles.find(
              (x) =>
                x.cycle == instance.cycle &&
                x.egress_profile == instance.egress_profile
            );
            list.push({
              id: instance.id,
              order: instance.order,
              sub_order: instance.sub_order,
              profile_cycle_order: profile_cycle_order
                ? profile_cycle_order.order
                : 9999,
              egress_profile: instance.egress_profile,
              competence: instance.competence,
              cycle: instance.cycle,
              action: get_competence.action,
              content: get_competence.content,
              condition: get_competence.condition,
              context: get_competence.context,
              full_sentence: get_competence.full_sentence,
              type: get_competence.type,
              verb: get_competence.verb,
              sentence: get_competence.sentence,
              name: get_competence.name,
              selected: get_competence.selected,
            });
          }
        }
      });
      const isEnac =
        this.institution && this.institution.internal_use_id === "enac.cl";
      return list.sort(function (a, b) {
        if (isEnac) {
          if (a.order !== b.order) return a.order - b.order;
          if (a.profile_cycle_order !== b.profile_cycle_order)
            return b.profile_cycle_order - a.profile_cycle_order;
          return a.sub_order - b.sub_order;
        }
        if (a.order > b.order) return 1;
        if (a.order < b.order) return -1;
        if (a.sub_order > b.sub_order) return 1;
        if (a.sub_order < b.sub_order) return -1;
        if (a.cycle > b.cycle) return 1;
        if (a.cycle < b.cycle) return -1;
        return 0;
      });
    },
    slotUpdatedMatter(matter) {
      this.$bvModal.hide(`modal-edit-matter-${matter.id}`);
    },
    slotCreatedMatter(matter) {
      this.$bvModal.hide("new-matter-modal");
      this.last_matter = matter.id;
      this.open_competence_modal = matter.id;
      // this.generic_table_key += 1;
      this.item_created_id = matter.id;
      clearTimeout(this.timeoutID);
      this.timeoutID = setTimeout(() => {
        this.open_competence_modal = null;
        this.last_matter = null;
      }, 1000);
      // window.scrollTo(0,document.body.scrollHeight)
      // if (this.matterList.length > 1) {
      //   setTimeout(() => {
      //     window.scrollTo(
      //       0,
      //       document.body.scrollHeight || document.documentElement.scrollHeight
      //     );
      //   }, 100);
      // }
    },
    matterModalities(modalities_ids) {
      return this.modalities.filter((x) => modalities_ids.includes(x.id));
    },
    // Determina si una fila tiene suficientes elementos para valer la pena contraerla.
    // Solo se consideran las columnas: competencias, unidades de competencia y RA micro.
    isRowCollapsible(matter) {
      if (!matter) return false;
      const counts = [
        this.columnItemCount(matter, "competences"),
        this.columnItemCount(matter, "temp_competence_unit"),
        this.columnItemCount(matter, "ra_micro"),
      ];
      return Math.max(...counts) >= this.collapse_threshold;
    },
    isRowExpanded(matter_id) {
      return this.expanded_rows.includes(matter_id);
    },
    // Cantidad de elementos apilados en una columna concreta de la fila
    columnItemCount(matter, key) {
      if (!matter) return 0;
      switch (key) {
        case "competences":
          return this.matterCompetences(matter).length;
        case "temp_competence_unit":
          return this.competence_units.filter((x) => x.matter == matter.matter)
            .length;
        case "ra_micro":
          return this.studyUnitList(matter).length;
        default:
          return 0;
      }
    },
    // ¿Mostrar el indicador "+N" en esta columna de una fila contraída?
    showColumnCountBadge(matter, key) {
      return (
        this.isRowCollapsed(matter) &&
        this.columnItemCount(matter, key) >= this.collapse_threshold
      );
    },
    // Los ámbitos que se ofrecen salen de las competencias de la asignatura: sin
    // competencias seleccionadas no hay nada que elegir, así que no se muestra el botón.
    canEditRealizationScopes(egress_profile_matter) {
      return (
        !egress_profile_matter.is_closed &&
        this.allows_crud &&
        this.can_update &&
        (egress_profile_matter.competences || []).length > 0
      );
    },
    openRealizationScopesModal(egress_profile_matter) {
      this.realization_scopes_matter = egress_profile_matter;
      this.show_realization_scopes_modal = true;
    },
    isRowCollapsed(matter) {
      return this.isRowCollapsible(matter) && !this.isRowExpanded(matter.id);
    },
    toggleRowExpansion(matter_id) {
      const index = this.expanded_rows.indexOf(matter_id);
      if (index === -1) this.expanded_rows.push(matter_id);
      else this.expanded_rows.splice(index, 1);
    },
    toggleAllRows() {
      if (this.allRowsExpanded) this.expanded_rows = [];
      else this.expanded_rows = [...this.collapsibleRowIds];
    },
  },
  created() {
    this.current_item = this.matterList;
    this.$store.dispatch(names.FETCH_MODALITIES);
    // Se cargan aunque la columna no se muestre: hacen falta para saber si el perfil tiene
    if (this.usesRealizationScopes)
      this.$store.dispatch(names.FETCH_REALIZATION_SCOPES, {
        egress_profile_id: this.egress_profile_id,
      });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateStickyHeaderSize);
  },
  watch: {
    egressProfile: function () {
      if (this.egressProfile)
        this.$store.dispatch(names.FETCH_CAREER, this.egressProfile.career);
    },
    matterList(newVal) {
      this.current_item = newVal;
    },
  },
  mounted() {
    this.totalRows = this.matterList.length;
    this.updateStickyHeaderSize();
    window.addEventListener("resize", this.updateStickyHeaderSize);
  },
};
</script>

<style scoped>
.v-select-class >>> .vs__selected {
  background-color: #6c757d98;
  color: #fff !important;
}
.container-v-select {
  display: flex;
  justify-content: right;
  align-items: center;
}
.text-filter-formative-line {
  white-space: nowrap;
}
.code-matter {
  border: 1px solid black;
  padding-top: 5px;
  font-weight: bold;
  font-size: 8pt;
  letter-spacing: 0.3px;
  margin-left: 15px;
}
html {
  scroll-behavior: smooth;
}
.table-container {
  padding-top: 0px;
  margin-top: 0px;
  z-index: 0;
}
.table-container-max-height {
  padding-top: 0px;
  margin-top: 0px;
  height: 100% !important;
}
.center-div-child {
  position: absolute;
  /* background: rgb(251, 251, 251); */
  padding: 0.6em 0;
  width: 50vh;
  top: 25%;
  left: 50%;
  border-radius: 3px;
  transform: translate(-50%, -50%);
}
th,
thead {
  position: sticky !important;
  top: 0 !important;
  margin-top: 0 !important;
  border-top: 0 solid black;
  width: 100vh;
}
th {
  position: sticky !important;
  z-index: 100;
  top: 0;
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
  font-size: var(--thirth-font-size);
  margin: 0px 0px;
  padding: 0px 20px;
  text-align: center;
  background: var(--secondary-color);
  color: white;
  border: 1px solid #000;
}
.icon-btn-ai {
  width: 18px;
  height: 18px;
}
::v-deep .btn-ai-custom {
  background-color: var(--kl-fourth-hover-color) !important;
  border-color: var(--kl-fourth-hover-color) !important;
  color: white !important;
}
::v-deep .btn-ai-custom:hover,
::v-deep .btn-ai-custom:focus,
::v-deep .btn-ai-custom:active {
  background-color: var(--kl-fourth-hover-color) !important;
  border-color: var(--kl-fourth-hover-color) !important;
  opacity: 0.9;
}
.b-table-sticky-header > .table.b-table > thead > tr > th {
  position: sticky !important;
}
.competence-order {
  font-size: var(--secondary-font-size);
}
.bottom-row {
  background: var(--secondary-color);
}
.new-matter-container {
  /* padding: 0.25em;
  width: 100% !important;
  height: max-content !important; */
  animation: blinker 1s linear 7;
}
.table-responsive >>> .table td {
  vertical-align: middle;
}
.form-group >>> .label-matter {
  font-size: var(--secondary-font-size);
}
/* .label {
  font-size: var(--secondary-font-color);
} */

.modalities-badge,
.certification-badge {
  font-size: 0.6rem;
  vertical-align: top;
  padding: 0.15rem 0.2rem;
  cursor: default !important;
}
@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.ra-macro-div {
  margin-left: 0em;
  /* word-break: break-all; */
  hyphens: auto;
}
.ra-micro-container {
  display: flex !important;
  flex-direction: column;
}
.ra-micro-content {
  border-bottom: 0.1px solid var(--secondary-color);
  margin: 0 !important;
  margin-top: 0.4em !important;
  min-height: fit-content;
}
.ra-micro-content:last-child {
  border-bottom: none;
}
.matter-link {
  font-size: 10pt;
}
/* Contracción de filas: limita la altura de cada celda cuando la fila
   está contraída, mostrando un degradado que indica que hay más contenido. */
.m2-collapsed {
  max-height: 7rem;
  overflow: hidden;
  position: relative;
}
.m2-collapsed::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2rem;
  pointer-events: none;
}
.collapse-toggle-btn {
  line-height: 1;
  color: var(--secondary-color);
}
.collapse-toggle-btn:hover {
  color: var(--kl-primary-button-hover-color);
}
/* Indicador "hay N elementos" en la esquina inferior de una columna contraída.
   Se dibuja por encima del degradado y es clicable para expandir la fila. */
.m2-more-indicator {
  position: absolute;
  bottom: 0.25rem;
  right: 0.35rem;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  gap: 0.15rem;
  padding: 0.05rem 0.4rem;
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1.4;
  color: #fff;
  background: var(--secondary-color);
  border-radius: 10rem;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  transition: background 0.2s, transform 0.2s;
}
.m2-more-indicator:hover {
  background: var(--kl-primary-button-hover-color);
  transform: translateY(-1px);
}
.btn-download-excel {
  min-width: 154px;
}
@media (max-width: 800px) {
  thead {
    width: 90vh;
    right: 0 !important;
  }
  .center-div-child {
    top: 30%;
  }
  .content-div {
    hyphens: auto;
  }
}
.pointer-class {
  cursor: pointer;
}

@media print {
  .table-responsive >>> .table {
    overflow: hidden !important;
  }
  /* En impresión siempre se muestran todas las filas expandidas,
     ignorando el estado de contracción de la vista en pantalla. */
  .m2-collapsed {
    max-height: none !important;
    overflow: visible !important;
  }
  .m2-collapsed::after {
    display: none !important;
  }
}
</style>